<div class="container-fluid">
  <h4>{{'Password.header' | translate}}</h4>
  <div class="row">
    <mat-form-field class="col-12">
      <mat-label>{{'Password.lblPasswordCurrent' | translate}}</mat-label>
      <input [type]="!isCurrentPasswordVisible ? 'password' : 'text'" matInput
        placeholder="{{'Password.lblPasswordCurrent' | translate}}" [(ngModel)]="changePassword.currentPassword"
        [ngModelOptions]="{standalone: true}" />
      <mat-icon class="clickable" matSuffix (click)="isCurrentPasswordVisible = !isCurrentPasswordVisible">
        {{!isCurrentPasswordVisible?
        'visibility_off' : 'visibility'}}</mat-icon>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field class="col-12">
      <mat-label>{{'Password.lblPasswordNew' | translate}}</mat-label>
      <input [type]="!isNewPasswordVisible ? 'password' : 'text'" matInput
        placeholder="{{'Password.lblPasswordNew' | translate}}" [(ngModel)]="changePassword.newPassword"
        [ngModelOptions]="{standalone: true}" />
      <mat-icon class="clickable" matSuffix (click)="isNewPasswordVisible = !isNewPasswordVisible">
        {{!isNewPasswordVisible?
        'visibility_off' : 'visibility'}}</mat-icon>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field class="col-12">
      <mat-label>{{'Password.lblPasswordNewConfirm' | translate}}</mat-label>
      <input [type]="!isNewPasswordVisible ? 'password' : 'text'" matInput
        placeholder="{{'Password.lblPasswordNewConfirm' | translate}}" [(ngModel)]="changePassword.newConfirmPassword"
        [ngModelOptions]="{standalone: true}" />
    </mat-form-field>
  </div>
  <div class="mt-3">
    <button mat-raised-button style="float: right;" color="primary" type="button" (click)="OnSavePassword()">{{'btnSave' |
      translate}}</button>
  </div>
</div>